var _defs, _polygon, _polygon2, _line, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteps01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Sign_Up",
    "data-name": "Sign Up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #df4f71;\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #df4f71;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "15.348 21.87 10.13 21.87 10.13 16.652 21.87 4.913 27.087 10.13 15.348 21.87"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.348 21.87 10.13 21.87 10.13 16.652 25.783 1 31 6.217 15.348 21.87"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.87,
    y1: 4.913,
    x2: 27.087,
    y2: 10.13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.696,16.652v13.043c0,.72-.584,1.304-1.304,1.304H2.304c-.72,0-1.304-.584-1.304-1.304V3.609c0-.72.584-1.304,1.304-1.304h13.043"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps01);
export default __webpack_public_path__ + "static/media/steps-01.3b7ff79d810231d57b69b19e3b52d475.svg";
export { ForwardRef as ReactComponent };